function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import { forwardRef } from "react";
import { jsx as _jsx } from "@classdojo/web/nessie/stylingLib/jsx-runtime";
var UnstyledButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var props = Object.assign({}, _ref);
  return _jsx("button", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    sx: {
      backgroundColor: "transparent",
      border: 0,
      padding: 0,
      textAlign: "inherit"
    } // Do something with the extra props
  }));
});

export default UnstyledButton;